import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App";
import { AuthGate, AuthProvider } from "./context/AuthContext";
import { CapabilitiesProvider } from "./context/CapabilitiesContext";
import { PortalProvider } from "./context/PortalContext";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HashRouter>
      <AuthProvider>
        <AuthGate>
          <CapabilitiesProvider>
            <PortalProvider><App /></PortalProvider>
          </CapabilitiesProvider>
        </AuthGate>
      </AuthProvider>
    </HashRouter>
  </React.StrictMode>,
);
